import React, { ReactElement, Ref } from 'react';

import PropTypes from 'prop-types';

import { stylePropType } from '@adsk/alloy-react-theme';

import MultiControl, {
  MultiControlProps,
} from '../../layout/Control/MultiControl';
import Tokens from '../../layout/Control/Tokens';
import { GenericItem } from '../../types';

const MultiDropdownTokenControlWrapped = <TItem extends GenericItem>(
  { style, ...props }: MultiControlProps<TItem>,
  ref: Ref<HTMLDivElement>,
) => (
  <MultiControl
    ref={ref}
    style={[
      {
        maxHeight: '6.25em',
        overflow: 'hidden',
      },
      style,
    ]}
    renderItems={({
      selectedItems,
      getSelectedItemProps,
      removeSelectedItem,
      itemToString,
    }) => (
      <Tokens
        selectedItems={selectedItems}
        getSelectedItemProps={getSelectedItemProps}
        removeSelectedItem={removeSelectedItem}
        itemToString={itemToString}
      />
    )}
    {...props}
  />
);

const MultiDropdownTokenControl = React.forwardRef(
  MultiDropdownTokenControlWrapped,
);

MultiDropdownTokenControl.displayName = 'MultiDropdownTokenControl';

MultiDropdownTokenControl.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Toggle disabled state */
  disabled: PropTypes.bool,
  /** Toggle loading state */
  isLoading: PropTypes.bool,
  /** Toggle error state */
  error: PropTypes.bool,
  /** Whether Dropdown menu is open */
  isOpen: PropTypes.bool.isRequired,
  /** Function to get props for the menu toggle button */
  getToggleButtonProps: PropTypes.func.isRequired,
  /** The content of te ControlContainer */
  children: PropTypes.any,
};

export default MultiDropdownTokenControl as <T extends GenericItem>(
  p: MultiControlProps<T> & { ref?: Ref<HTMLDivElement> },
) => ReactElement;
